(() => {
  const LIBRARY_URL =
    "https://unpkg.com/html5-qrcode@2.3.8/html5-qrcode.min.js";

  let scanner = null;
  let modal = null;
  let closing = false;

  function loadLibrary() {
    if (window.Html5Qrcode) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = LIBRARY_URL;
      script.onload = resolve;
      script.onerror = () => reject(
        new Error("No se pudo cargar el lector.")
      );
      document.head.appendChild(script);
    });
  }

  async function closeScanner() {
    if (closing) return;
    closing = true;

    if (scanner) {
      try {
        await scanner.stop();
      } catch (e) {}
      try {
        scanner.clear();
      } catch (e) {}
      scanner = null;
    }

    modal?.remove();
    modal = null;
    closing = false;
  }

  async function openScanner() {
    if (modal) return;

    modal = document.createElement("div");
    modal.style.cssText = `
      position:fixed;
      inset:0;
      z-index:2147483647;
      background:rgba(0,0,0,.85);
      display:flex;
      align-items:center;
      justify-content:center;
      padding:16px;
    `;

    modal.innerHTML = `
      <div style="
        background:white;
        color:#222;
        border-radius:12px;
        padding:20px;
        width:100%;
        max-width:420px;
        text-align:center;
      ">
        <h2 style="font-size:20px;margin:0 0 12px">
          Escanear prenda
        </h2>
        <p style="font-size:14px;margin-bottom:15px">
          Enfoca el código de barras de la etiqueta.
        </p>
        <div id="ha-scanner-reader"></div>
        <p id="ha-scanner-status"
           role="status"
           style="font-size:13px;margin:12px 0">
          Preparando cámara...
        </p>
        <button id="ha-scanner-close"
          type="button"
          style="
            padding:12px 25px;
            margin-top:10px;
            border:1px solid #222;
            background:white;
            color:#222;
            cursor:pointer;
          ">
          Cerrar
        </button>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector("#ha-scanner-close")
      .addEventListener("click", closeScanner);

    const status = modal.querySelector(
      "#ha-scanner-status"
    );

    try {
      await loadLibrary();
      if (!modal) return;

      scanner = new Html5Qrcode(
        "ha-scanner-reader",
        {
          formatsToSupport: [
            Html5QrcodeSupportedFormats.EAN_13,
            Html5QrcodeSupportedFormats.EAN_8,
            Html5QrcodeSupportedFormats.CODE_128,
            Html5QrcodeSupportedFormats.UPC_A,
            Html5QrcodeSupportedFormats.UPC_E
          ],
          verbose: false
        }
      );

      await scanner.start(
        { facingMode: "environment" },
        {
          fps: 10,
          qrbox: (width, height) => ({
            width: Math.min(280, Math.floor(width * 0.85)),
            height: Math.min(140, Math.floor(height * 0.5))
          })
        },
        async (decodedText) => {
          status.textContent = "Producto encontrado. Buscando...";
          await closeScanner();

          const url = new URL(
            "/search",
            window.location.origin
          );

          url.searchParams.set("q", decodedText);
          url.searchParams.set("type", "product");
          url.searchParams.set("ha_scan", "1");

          window.location.assign(url.toString());
        },
        () => {}
      );

      if (modal) {
        status.textContent = "Apunta al código de barras.";
      }
    } catch (error) {
      if (modal) {
        status.textContent =
          "No se pudo abrir la cámara. Comprueba los permisos de Safari o Chrome.";
      }
      console.error("Hello Australian scanner:", error);
    }
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest(
      ".ha-barcode-button"
    );

    if (!button) return;

    event.preventDefault();
    openScanner();
  });
})();

(() => {
  function abrirVarianteEscaneada() {
    const params = new URLSearchParams(
      window.location.search
    );

    if (params.get("ha_scan") !== "1") return;

    const codigo = params.get("q");
    if (!codigo) return;

    const coincidencias = Array.from(
      document.querySelectorAll(".ha-scan-variant")
    ).filter((elemento) => {
      return elemento.dataset.barcode === codigo;
    });

    if (coincidencias.length !== 1) return;

    const destino = coincidencias[0].dataset.url;

    if (destino) {
      window.location.replace(destino);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      abrirVarianteEscaneada
    );
  } else {
    abrirVarianteEscaneada();
  }
})();
